import { Injectable } from '@angular/core';
import { HashLocationStrategy } from '@angular/common';

@Injectable()
export class ParameterHashLocationStrategy extends HashLocationStrategy {
	// This is to make ?pub=<publication> possible, otherwise ?pub= will get removed from the url :(
	prepareExternalUrl(internal: string): string {
		return window.location.search + super.prepareExternalUrl(internal);
	}
}
